import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import styles from "./ServiceDebtOverlay.module.scss";
import type { SingleDebt } from "../../../hooks/useServiceDebt";

interface Props {
  serviceDebt: SingleDebt;
  orderDebt: SingleDebt;
}

const ServiceDebtOverlay = ({ serviceDebt, orderDebt }: Props) => {
  const navigate = useNavigate();

  let message: string | null = null;
  let btnLabel = "";
  let destination = "";

  if (serviceDebt.hasDebt) {
    message = serviceDebt.message || "Xidmət borcunuz mövcuddur. Zəhmət olmasa əvvəlcə borcunuzu ödəyin.";
    btnLabel = "Xidmət borcları";
    destination = "/account/service-debts";
  } else if (orderDebt.hasDebt) {
    message = orderDebt.message || "Sifariş et borcunuz mövcuddur. Zəhmət olmasa əvvəlcə borcunuzu ödəyin.";
    btnLabel = "Sifariş et";
    destination = "/account/special-order";
  }

  if (!message) return null;

  return createPortal(
    <div className={styles.overlay}>
      <div className={styles.card}>
        <div className={styles.icon}>⚠️</div>
        <p className={styles.message}>{message}</p>
        <button className={styles.btn} onClick={() => navigate(destination)}>
          {btnLabel}
        </button>
      </div>
    </div>,
    document.body
  );
};

export default ServiceDebtOverlay;
